import styled from '@emotion/styled'
import { scaleLinear } from 'd3-scale'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { Flex } from '../atoms/Basics'

const Tick = styled.div`
  position: absolute;
  left: ${(props) => props.tick};
  bottom: 0;
  color: ${(props) => props.theme.colors.gray};
  height: 0.6rem;
  border-right: 1px solid gray;
`

const TickLabel = styled.div`
  position: absolute;
  left: ${(props) => props.tick};
  bottom: 0.75rem;
  font-size: 0.75rem;
  color: ${(props) => props.theme.colors.gray};
  text-align: center;
  ${Mq.sm} {
    font-size: 0.5rem;
  }
`

const PercentTickAxis = () => {
  const x = scaleLinear([0, 100], [0, 100])
  const xTicks = x.ticks(10)

  const center = (tick) => {
    return tick < 10 ? 0.5 : tick < 100 ? 0.9 : 1.75
  }

  return (
    <Flex>
      {xTicks.map((tick) => {
        return (
          <div key={tick}>
            <TickLabel tick={`${tick - center(tick)}%`}>{tick}%</TickLabel>
            <Tick tick={`${tick}%`} />
          </div>
        )
      })}
    </Flex>
  )
}

export default PercentTickAxis
